import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <RankingSection />
        <UpdatesSection />
        <FaqSection />
        <MediaSection />
        <TopicsSection />
        <FeaturesSection />
        <CommentsSection />
        <AboutSection />
        <AppSection />
        <IndexSection />
        <CarouselSection />
        <CardsSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
}